

export default {
    vi : {
        header: 'Tạo tài khoản mới',
        description: 'Điền đầy đủ và chính xác tên tài khoản và mật khẩu',
        username: 'Tên tài khoản',
        password: 'Mật khẩu',
        repassword: 'Nhập lại mật khẩu',
        invalidUsername: 'Tên tài khoản không hợp lệ',
        invalidPassword: 'Mật khẩu phải có tối thiểu 8 ký tự bao gồm số, chữ hoa, chữ thường và ký tự đặc biệt',
        invalidRepassword: 'Hai mật khẩu không trùng nhau',
        button: 'Tạo tài khoản',
        login: 'Quay lại đăng nhập',
        others: 'Hoặc đăng ký với'
    },
    en: {
        header: 'Create a new account',
        description: 'Enter your username and password',
        username: 'Username',
        password: 'Password',
        repassword: 'Enter password once more time',
        invalidUsername: 'Invalid username',
        invalidPassword: 'Password must has at least 8 characters including numbers, lowercase letters, uppercase letters, and special characters',
        invalidRepassword: 'The two passwords do not match',
        button: 'Create account',
        login: 'Back to login',
        others: 'Register with other options'
    }
};


